import { NodePositionChange, Node } from '@xyflow/react';
import { useCallback } from 'react';
import { RfNodeStandalone } from '../../canvas-types/nodeTypesData';
import { ObjectOperations } from '../objectOperations';
import { SweepCanvasRfNode } from '../../canvas-types/nodeTypesData';
import { CanvasEventType, CanvasMoveStandaloneNodeEvent } from '../../canvas-types';
import { useSectionableNodeMoveEvent } from './useSectionableNodeMoveEvent';

export const useOnStandaloneNodePositionChange = () => {
  const { createSectionableNodeMoveEvent } = useSectionableNodeMoveEvent();

  const onStandaloneNodePositionChange = useCallback(
    ({
      nodeChange,
      node,
      nodeOperations,
      intersectionSectionNode,
    }: {
      nodeChange: NodePositionChange;
      node: RfNodeStandalone;
      nodeOperations: ObjectOperations<SweepCanvasRfNode>;
      intersectionSectionNode: Node | null;
    }): CanvasMoveStandaloneNodeEvent | null => {
      nodeOperations.setObject(node.id, (node) => ({
        ...node,
        expandParent: !nodeChange.dragging,
      }));

      if (!nodeChange.dragging) {
        const moveEvent = createSectionableNodeMoveEvent({
          nodeChange,
          node,
          nodeOperations,
          intersectionSectionNode,
        });
        if (!moveEvent) {
          return null;
        }

        return {
          type: CanvasEventType.MoveStandaloneNode,
          nodeId: moveEvent.nodeId,
          newPosition: moveEvent.canvasGridPosition,
          parentId: moveEvent.parentId,
        };
      }
      return null;
    },
    [createSectionableNodeMoveEvent],
  );

  return {
    onStandaloneNodePositionChange,
  };
};
